import React from "react";
import PageAncestor from "core/common/page/pageAncestor";
import Toolmenu from "core/components/toolmenu/toolmenu";
import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import mdEntityService from "core/metamodel/mdEntityService";
import Grid, {GridRow} from 'core/grid/domain/grid';
import {ErrorComp} from "core/components/errorComp/errorComp";
import {lovValue} from "core/form/formUtils";
import gridService from "core/grid/gridService";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import {ID, MODULE, PageProps, PERMISSION} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {action, observable} from "mobx";
import certificateService from "administration/certificate/certificateService";
import {CERTFORMAT, CERTTYPE, MdCertificate} from "administration/certificate/certificateDomain";
import Paper from "material-ui/Paper";
import List from "material-ui/List/List";
import ListItem from "material-ui/List/ListItem";
import {formatDateTime} from "core/common/utils/dateUtils";
import {LovItem} from "core/metamodel/mdEntity";
import {DialogAncestor, DialogProps} from "core/common/page/dialogAncestor";
import FlatButton from "material-ui/FlatButton";
import Dialog from "material-ui/Dialog";
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import documentService from "core/document/documentService";
import {fieldStyles} from "core/form/createForm";
import {MdTextField} from "core/components/fields/fields";
import RadioButtonField from "core/components/fields/radioButtonField";
import {loc} from "../../core/common/config/locales";


@observer
export default class CertificateDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'Certificate';
  static icon = 'certificate';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("CertificateDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['MdCertificate'], [{entity: "CERTFORMAT", lov: true}]);

    let certificatePromise: Promise<MdCertificate> = certificateService.readCertificate(routerParams.id);


    return Promise.all([metadataPromise, certificatePromise])
      .then(([entityMap, certificateObject]: [any, MdCertificate]) => {

        certificateService.certificateObject = certificateObject.initAfterRead(false);
      });
  }

  private exportCertificateDialog: ExportCertificateDialog;

  componentWillUnmount() {
    certificateService.certificateObject = null;
  }


  findRootObject() {
    return certificateService.certificateObject;
  }




  @action onDelete = (evt) => {
    console.log('onDelete');
    certificateService.deleteCertificate(certificateService.certificateObject.certificateId)
      .then(response => {
        this.context.router.transitionTo('certificateList');
      });
  };

  @action onExport = (evt) => {
    console.log('onExport');

    let dto: ExportCertificateDialogDto = {
      certificate: certificateService.certificateObject,
      certFormat: mdEntityService.getEntity("CERTFORMAT").getLovItem(CERTFORMAT.X509_BASE64),
      password: ""
    };

    new Promise((resolve, reject) => {
      this.exportCertificateDialog.open(resolve, reject, observable(dto));
    }).then((dto: ExportCertificateDialogDto) => {



    }).catch((e) => {
    });

  };


  exportCertificateDialogfHandler = comp => this.exportCertificateDialog = comp;

  render() {

    let {
      query
    } = this.props;

    let certificate = certificateService.certificateObject;

    let errors = (!certificate.valid) ? [{message: certificate.validError}] : [];


      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'column'}} >
          <Toolmenu backAction={this.onBack} backDisabled={History.length <= 1}>
            <WithDeleteDialogZzFlatButton entityName="MdCertificate" pageAncestor={this} onClick={this.onDelete} label="Delete" permission={PERMISSION.Delete}/>
            <ZzFlatButton onClick={this.onExport} label="Export" permission={PERMISSION.Export}/>
          </Toolmenu>
          <ErrorComp messages={errors} />
          <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
          <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
          <ExportCertificateDialog ref={this.exportCertificateDialogfHandler}/>

          <Paper style={{marginTop: 15, padding: 8}} zDepth={1}>
            <h4 style={{marginLeft: 15}}>Certificate Detail</h4>

            <List>
              <ListItem>
                <span>Valid</span>
                <p><span className={(certificate.valid) ? "fa fa-certificate color-green-500" : "fa fa-certificate color-red-500"}/></p>
              </ListItem>
              <ListItem>
                <span>Subject</span>
                <p><b>{certificate.subjectCn}</b></p>
              </ListItem>
              <ListItem>
                <span>Issuer</span>
                <p><b>{certificate.issuerCn}</b></p>
              </ListItem>
              <ListItem>
                <span>Serial Number</span>
                <p><b>{certificate.serialNumber}</b></p>
              </ListItem>
              <ListItem>
                <span> Validity </span>
                <p><b> {formatDateTime(certificate.fromDate)} - {formatDateTime(certificate.toDate)} </b></p>
              </ListItem>
              <ListItem>
                <span>Changed at</span>
                <p><b>{formatDateTime(certificate.dateUpdated)}</b></p>
              </ListItem>
              <ListItem>
                <span>Changed by</span>
                <p><b>{certificate.userCreated}</b></p>
              </ListItem>
            </List>
          </Paper>

          <Paper zDepth={1} style={{marginTop: 15, padding: 8}}>
            <h4 style={{marginLeft: 15}}>X509</h4>
            <pre>
                {certificate.x509String}
            </pre>
          </Paper>


        </main>
      )
  }

}


interface ExportCertificateDialogDto {
  certificate: MdCertificate;
  certFormat?: LovItem;
  password?: string;
}


@observer
class ExportCertificateDialog extends DialogAncestor<DialogProps, undefined, ExportCertificateDialogDto> {

  dto: ExportCertificateDialogDto;

  @action open(resolve, reject, dto: ExportCertificateDialogDto) {
    this.resolve = resolve;
    this.reject = reject;
    this.dialogOpen = true;
    this.dto = dto;
  }




  @action export = (evt) => {
    console.log('ExportCertificateDialog#ok evt = %O', evt);

    this.dialogOpen = false;
    this.$errors = [];
    this.resolve(this.dto);
  };


  @action cancel = (evt) => {
    console.log('ExportCertificateDialog#cancel evt = %O', evt);
    this.dialogOpen = false;
    this.$errors = [];
    this.reject("cancel");
  };

  @action onChangeCertFormat = (lovItem) => {
    console.log('onChangeCertFormat lovItem = %O', lovItem);
    this.dto.certFormat = lovItem;
    this.dto.password = "";
  };
  @action onChangePassword = (evt) => {
    this.dto.password = evt.target.value;
  };


  render() {

    if (!(this.dialogOpen)) return null;

    return (
      <Dialog
        title="Export Certificate"
        actions={[<FlatButton label="Export" href={certificateService.exportCertificateUrl(lovValue(this.dto.certFormat) as CERTFORMAT, this.dto.certificate.certificateId, this.dto.password)}
                              secondary onClick={this.export} disabled={(lovValue(this.dto.certFormat) === CERTFORMAT.PKCS_12) && !this.dto.password}/>, <FlatButton label="Cancel" primary onClick={this.cancel}/>]}
        modal={true}
        open={this.dialogOpen}
        bodyStyle={{minHeight: 180}}
        contentStyle={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', filter: 'blur(0)'}}
      >

        <form>
          <RadioButtonField onChange={this.onChangeCertFormat} name="certFormat" {...fieldStyles.small.radioButton} value={this.dto.certFormat}
          options={mdEntityService.getEntity("CERTFORMAT").lovItems} disabled={disabledPKCS.bind(this, this.dto.certificate)}
          />
          {(lovValue(this.dto.certFormat) === CERTFORMAT.PKCS_12) ? (
            <MdTextField {...fieldStyles.small.textField} value={this.dto.password}  type="password" errorText={(this.dto.password)?undefined:"Password is required"} onChange={this.onChangePassword} fullWidth hintText="Password" />
          ) : null}

        </form>


      </Dialog>
    );
  }


}


function disabledPKCS(certificate: MdCertificate, lov: LovItem) {
  return (lovValue(certificate.certType) !== CERTTYPE.PRIVATE && lovValue(lov) === CERTFORMAT.PKCS_12);
}



// WEBPACK FOOTER //
// ./src/administration/certificate/CertificateDetail.tsx